/**
 * Placeholder/legacy content that should no longer appear on the public site.
 *
 * These job postings were never real open roles — they were thin seed entries
 * ("Senior ERP Consultant" / "AI Solutions Architect" with a one-line
 * description). They are filtered out of every public surface (listings, job
 * pages, sitemap, prerender) and redirected to /careers by the prerenderer.
 */
export const RETIRED_JOB_IDS = ['career-1', 'career-2'];

/** True when a job id/slug belongs to a retired placeholder posting. */
export function isRetiredJob(idOrSlug?: string): boolean {
  if (!idOrSlug) return false;
  const key = String(idOrSlug).trim();
  return RETIRED_JOB_IDS.includes(key);
}